import "core-js/modules/es.array.push.js";
import axios from "axios";
import { inject, shallowRef } from "vue";
import { mapMutations } from "vuex";
import EpInfoFilled from '~icons/ep/info-filled';
export default {
  data() {
    return {
      paths: [{
        name: "Профиль",
        path: "/rol-shop/profile"
      }, {
        name: "Адрес доставки",
        path: "/rol-shop/profile/address"
      }]
    };
  },
  methods: {
    ...mapMutations({
      setPaths: "crumbs/setPaths"
    }),
    async fetchAddress() {
      let apiRes = null;
      try {
        const {
          data
        } = await axios.get(`https://c2ff7a8de0a119c8.mokky.dev/address`);
        this.address = data;
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        if (apiRes == 404) {
          this.$router.push("/rol-shop/404");
        }
      }
    },
    async removeAddress(id) {
      let apiRes = null;
      try {
        await axios.delete(`https://c2ff7a8de0a119c8.mokky.dev/address/${id}`);
        let index = this.address.findIndex(item => item.id === id);
        if (index !== -1) {
          this.address.splice(index, 1);
        }
      } catch (err) {
        apiRes = err.response.status;
      } finally {
        if (apiRes == 404) {
          this.$router.push("/rol-shop/404");
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.setPaths(vm.paths);
    });
  },
  mounted() {
    this.fetchAddress();
  },
  setup() {
    const {
      address
    } = inject("address");
    const iconInfo = shallowRef(EpInfoFilled);
    return {
      address,
      iconInfo
    };
  }
};